/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Plan_RdlInputs */

const en_platform_plan_rdl = /** @type {(inputs: Platform_Plan_RdlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Romanian deadlift`)
};

const pl_platform_plan_rdl = /** @type {(inputs: Platform_Plan_RdlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Martwy ciąg rumuński`)
};

/**
* | output |
* | --- |
* | "Romanian deadlift" |
*
* @param {Platform_Plan_RdlInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_plan_rdl = /** @type {((inputs?: Platform_Plan_RdlInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Plan_RdlInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_plan_rdl(inputs)
	return en_platform_plan_rdl(inputs)
});